import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import MonthlyPrice$1 from './MonthlyPrice.js';
import { useLensBundle } from '../../../../LensBundles/context.js';

const MonthlyPriceContainer = ()=>{
    const { currency , getLabel  } = useIntl();
    const { pricePerMonth  } = useLensBundle();
    const labels = React__default.useMemo(()=>({
            perMonth: getLabel('common.frequency.perMonth')
        })
    , [
        getLabel
    ]);
    if (!pricePerMonth) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(MonthlyPrice$1, {
        currency: currency,
        labels: labels,
        price: pricePerMonth
    });
};
var MonthlyPrice = MonthlyPriceContainer;

export { MonthlyPrice as default };
//# sourceMappingURL=MonthlyPriceContainer.js.map
